<template>
    <pw-layout>
        <template slot="headerRight">
            <b-button class="headerSubMenu" size="sm" @click="logoutClickHandler" id="userLogoutButton">
                {{ $t('login.logout') }} 
            </b-button>
            <b-tooltip target="userLogoutButton" placement="left">{{ currentUser }}</b-tooltip>
        </template>
        
        <div class="row">
            <div class="col-12">
                <filter-form
                    @setFilter="filterResultSet">
                </filter-form>
            </div>
        </div>
        
        <hr/>

        <div class="row">
            <div class="col-12">
                <results-table
                    @showNewModal="showNewElementModal"
                    @showEditModal="showEditModal"
                    @sort="adjustSorting"
                    @nextPage="nextPageClickHandler"
                    @firstPage="initializeData(false)"
                    :nextEnabled="paginate"
                    :firstEnabled="resetPagination"
                    :allowedSortings="allowedSortings"
                    :loading="loading"
                    :configurations="configurations">
                </results-table>
            </div>
        </div>

        <b-modal id="NewElementModal" size="xl" scrollable @ok="saveTermsSetHandler" title="### Title ###">
            <template v-slot:modal-title>
               {{ editFormTitle }}
            </template>
            
            <update-form
                :formModel="updateForm"
                @updateFile="updateFile"
                @change="setUpdateForm"
            ></update-form>
        </b-modal>
    </pw-layout>
</template>

<script>
    import PwLayout from "@/components/PwLayout.vue";
    import FilterForm from "@/components/FilterForm.vue";
    import ResultsTable from "@/components/ResultsTable.vue";
    import UpdateForm from "@/components/UpdateForm.vue";
    import _has from 'lodash/has';
    import _get from 'lodash/get';
    import _clone from 'lodash/clone';
    import LoadingIndicator from '@/components/LoadingIndicator.vue'
    import moment from 'moment';
    import firebase from 'firebase';

    export default {
        components: {
            PwLayout,
            FilterForm,
            UpdateForm,
            LoadingIndicator,
            ResultsTable
        },
        data() {
            return {
                updateForm: {},
                paginate: false,
                resetPagination: false,
                lastItem: null,
                maxItems: 20,
                configurations: [],
                uploadFileData: null,
                updateProcess: false,
                filter: {},
                loading: false,
                sortSettings: ['valid_from', 'asc'],
                allowedSortings: {
                    'to_code': true,
                    'valid_from': true,
                    'active': true
                },
                requiredFields: ['name', 'to_code'],
                filterSortExceptions: ['to_code', 'active']
            };
        },

        computed: {
            currentUser() {
                return firebase.auth().currentUser.email;
            },
            editFormTitle() {
                let mode = this.updateProcess ? this.$t('update.edit') : this.$t('update.create');
                return `${mode} ${this.$t('update.title')}`;
            }
        },
        methods: {
            showNewElementModal() {
                this.resetFormValues();
                this.$bvModal.show('NewElementModal');
            },
            showEditModal(data) {
                this.$bvModal.show('NewElementModal');
                this.updateProcess = true;
                this.updateForm = data;
            },
            saveTermsSetHandler (event) {
                if (!this.checkFields() || !this.updateProcess && this.uploadFileData === null) {
                    event.preventDefault();
                    this.$toastr.e(this.$t('update.validationerror'));
                    return;
                }
                
                this.saveTermsSet();
            },
            saveTermsSet() {
                
                this.loading = true;
                if (!this.updateProcess) {
                    this.getFirestoreRef().add(this.formatedQueryObject(this.updateForm))
                        .then(result => {
                            this.updateProcess = true;
                            this.updateForm.id = result.id;
                            this.saveTermsSetHandler();
                        })
                        .catch(error => {
                            this.loading = false;
                            this.$toastr.e(error.message);
                        });
                    return;
                } else {
                    if (!this.uploadFileData && this.updateProcess) {
                        this.updateFirestoreData();
                        return;
                    }
                    this.storeFileData()
                        .then(url => {
                            this.updateForm.file = url;
                            this.updateFirestoreData();
                        });
                }
            },
            storeFileData() {
                let storageRef = firebase.storage().ref();
                let fileExt = this.uploadFileData.name.split('.');
                    fileExt = fileExt[fileExt.length-1];

                let fileName = this.updateForm.to_code + '/' + this.updateForm.id;
                let uploadFileData = this.uploadFileData;
                return new Promise((resolve, reject) => {
                    let uploadTask = storageRef
                        .child(fileName)
                        .put(uploadFileData);
                    
                    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
                        snapshot => {},
                        error => {
                            this.$toastr.e(error.message);
                        }, 
                        () => {
                            uploadTask.snapshot.ref.getDownloadURL()
                                .then(url => {
                                    resolve(url);
                                });
                        });
                });
                
            },
            updateMetadata(id) {
                return new Promise((resolve, reject) => {
                    let fileRef = this.getStorageRef(this.updateForm.to_code, id);
                    let metaData = {
                        customMetadata: {
                            'name': ( this.updateForm.name !== '' ) ? this.updateForm.name : null
                        }
                    };
                    fileRef.updateMetadata(metaData)
                        .then(result => {
                            resolve();
                        })
                        .catch(() => {
                            this.$toastr(this.$t('update.metadata.fail'));
                            resolve();
                        });
                });
            },
            formatedQueryObject(updateForm) {
                let query = _clone(updateForm);
                if (query.valid_from && query.valid_from !== '') {
                    query.valid_from = new Date(moment(query.valid_from).unix() * 1000);
                }
                delete query.id;
                return query;
            },
            updateFirestoreData() {
                let id = this.updateForm.id;
                this.updateMetadata(id)
                    .then(() => {
                        this.getFirestoreRef().doc(id).update(this.formatedQueryObject(this.updateForm))
                            .then(result => {
                                this.initializeData();
                                this.$toastr.s(this.$t('update.data.success'))
                            })
                            .catch(() => {
                                this.$toastr.e(this.$t('update.data.fail'))
                            });
                    });
            },
            initializeData(indexed = false) {
                let filterQuery  = this.formatedQueryObject(this.filter);

                this.loading = true;
                if(!indexed) {
                    this.resetPagination = false;
                    this.lastItem = null;
                }
                this.configurations = [];
                let termsRef = this.getFirestoreRef()
                    .orderBy(this.sortSettings[0], this.sortSettings[1]);
                
                if (this.paginate && this.lastItem) {
                    termsRef = termsRef.startAfter(this.lastItem);
                }
                
                termsRef = termsRef.limit(this.maxItems);

                let filterSet = Object.keys(filterQuery);
                if (filterSet.length > 0) {
                    for (let i=0; i<filterSet.length; i++) {
                        if (filterQuery[filterSet[i]] === '') {
                            continue;
                        }
                        let operator = (filterSet[i] === 'valid_from') ? '>=' : '==';
                        termsRef = termsRef.where(filterSet[i], operator, filterQuery[filterSet[i]]);
                    }
                } 
                
                let getDoc = termsRef.get()
                    .then(response => {
                        this.resultPagination(response.size >= this.maxItems);
                        this.lastItem = response.docs[response.docs.length-1];
                        response.docs.map(doc => {
                            let dataSet = doc.data();
                            dataSet.id = doc.id;
                            this.configurations.push(dataSet);
                        })
                        this.loading = false;
                    })
                    .catch(error => {
                        this.$toastr.e(error.message);
                        this.loading = false;
                    });
            },
            resultPagination(allow) {
                this.paginate = allow;
            },
            updateFile(file) {
                this.uploadFileData = file;
            },
            checkFields() {
                let valid = true
                this.requiredFields.forEach(field => {
                    if(typeof(this.updateForm[field]) === 'undefined' || this.updateForm[field] === '') {
                        valid = false;
                    }
                });
                return valid;
            },
            setUpdateForm(data) {
                this.updateForm = data;
            },
            resetFormValues() {
                this.updateForm = {};
                this.updateProcess = false;
                this.uploadFileData = null;
            },
            logoutClickHandler() {
                firebase.auth().signOut().then(
                    () => {
                        this.$router.push('/');
                        this.$toastr.s('logged out');
                    },
                    error => {
                        this.$toastr.e(`error ${error.message}`);
                    }
                );
            },
            nextPageClickHandler() {
                this.initializeData(true)
                this.resetPagination = true;
            },
            adjustSorting(settings) {
                this.sortSettings = settings;
                this.initializeData();
            },
            filterResultSet(filter) {
                this.updateSortingFields(filter);
                this.filter = filter;
                this.initializeData();
            },
            updateSortingFields(filter) {
                this.filterSortExceptions.forEach(key => {
                    if (filter.valid_from || key in filter && filter[key] !== '') {
                        this.allowedSortings[key] = false;
                    } else {
                        this.allowedSortings[key] = true;
                    }
                    this.sortSettings = ['valid_from', 'asc'];
                });
            },
            getStorageRef(to, id) {
                let storage = firebase.storage().ref();
                return(
                    storage.child(`${to}/${id}`)
                );
            },
            getFirestoreRef() {
                return(
                    firebase.firestore()
                        .collection('TAC')
                        .doc('tac_configurations')
                        .collection('configurations')
                );
            }
        },

        watch: {
            presetKey: {
                handler: function(val, oldVal) {
                    this.onPropertyChanged(val, oldVal);
                }
            }
        },
        mounted() {
            this.initializeData();
        }
    };
</script>

<style scoped lang="scss">

</style>